import { useParams, useSearchParams, Link } from 'react-router-dom';
import { XCircle, Home, RefreshCw } from 'lucide-react';

export default function CheckoutError() {
  const { token } = useParams<{ token: string }>();
  const [searchParams] = useSearchParams();
  const message = searchParams.get('message') || 'Ocorreu um erro ao processar o pagamento';

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full">
        <div className="bg-white rounded-lg shadow-lg p-8 text-center">
          <div className="mb-6">
            <div className="mx-auto w-20 h-20 bg-red-100 rounded-full flex items-center justify-center">
              <XCircle className="h-12 w-12 text-red-600" />
            </div>
          </div>

          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Pagamento Não Aprovado
          </h1>

          <p className="text-lg text-gray-600 mb-8">
            {message}
          </p>

          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 mb-8">
            <h3 className="font-semibold text-gray-900 mb-3">O que fazer agora?</h3>
            <ul className="text-left space-y-2 text-gray-600">
              <li className="flex items-start">
                <span className="text-yellow-600 mr-2">•</span>
                <span>Verifique se os dados do cartão estão corretos</span>
              </li>
              <li className="flex items-start">
                <span className="text-yellow-600 mr-2">•</span>
                <span>Confirme se há limite disponível no cartão</span>
              </li>
              <li className="flex items-start">
                <span className="text-yellow-600 mr-2">•</span>
                <span>Tente usar outro método de pagamento</span>
              </li>
              <li className="flex items-start">
                <span className="text-yellow-600 mr-2">•</span>
                <span>Entre em contato com seu banco se o problema persistir</span>
              </li>
            </ul>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to={`/checkout/${token}`}
              className="inline-flex items-center justify-center px-6 py-3 bg-blue-500 text-white rounded-lg font-semibold hover:bg-blue-600 transition-colors"
            >
              <RefreshCw className="h-5 w-5 mr-2" />
              Tentar Novamente
            </Link>

            <Link
              to="/"
              className="inline-flex items-center justify-center px-6 py-3 bg-gray-200 text-gray-700 rounded-lg font-semibold hover:bg-gray-300 transition-colors"
            >
              <Home className="h-5 w-5 mr-2" />
              Voltar para o Início
            </Link>
          </div>

          <p className="text-sm text-gray-500 mt-8">
            Precisa de ajuda? Entre em contato conosco pelo WhatsApp
          </p>
        </div>
      </div>
    </div>
  );
}
